<template>
  <main class="main">
      <organization_header :rate="rate"/>
      <div class="table">
        <loading-container :loading="loading" >
        <table >
          <tr>
            <!--<th>Фото</th>-->
            <th style="width: 50%;">Название</th>
            <th>Статус</th>
          </tr>
          <tr v-for="item in brands" :key="item.id">
            <!--<td class="tc">
                <img class="brand-img" :src="item.image" alt="">
            </td>-->
            <td class="tc">
                {{item.name}}
            </td>
            <td class="tc">
                {{item.status}}
            </td>
          </tr>
          <tr>
              <!--<td class="tc">
                  <app-button @click="fileInput" outlined class="ml-2">Логотип</app-button>
                  <input type="file" ref="file" v-validate="'required'" data-vv-validate-on="blur" data-vv-as="логотип" hidden name="photo" accept=".jpg, .jpeg, .png, .bmp"  @change="onFileChange">
                  <span class="text-danger text-sm">{{ errors.first('photo') }}</span>
              </td>-->
              <td>
                  <input autocomplete="off" type="text" v-validate="'required'" data-vv-as="название" name="name" v-model="name" value="">
                  <span class="text-danger text-sm">{{ errors.first('name') }}</span>
              </td>
              <td>
                  <app-select :options="statuses"
                              v-model="status"
                              v-validate.persist="'required'"
                              name="status"
                              data-vv-as="статус"
                              :placeholder="'Статус'"/>
                  <span class="text-danger text-sm">{{ errors.first('status') }}</span>
              </td>
          </tr>
        </table>
        <button class="btn-join" @click="send()">Сохранить</button>
      </loading-container>
      </div>
      <pagination
          :key="paginat"
          v-show="last_page > 1"
          v-model="page"
          :page-count="last_page"
      />
  </main>
</template>

<script>

import LoadingContainer from "@/components/loading-container";
import Pagination from "@/components/pagination";
/*import AppButton from "@/components/app-button";*/
import AppSelect from "@/components/app-select";
import organization_header from "@/components/OrganizationHeader.vue"

export default {
  name: "import-log",
  components: {
    LoadingContainer,
    Pagination,
    /*AppButton,*/
    AppSelect,
    organization_header
  },
  data: ()=>({
    last_page: 0,
    paginat: null,
    page: 0,
    name: '',
    loading: true,
    brands: null,
    file: null,
    status: 'Эксклюзивный дистрибьютор',
    statuses: [
        'Эксклюзивный дистрибьютор',
        'Официальный дистрибьютор',
        'Производитель'
    ]
  }),
  mounted() {
    this.getBrands();
  },
  methods: {
    getBrands(){
      this.$http.post('/get-brands', {
        token: localStorage.getItem('token'),
        page: this.page
      }).then(({data}) => {
        if (data.brands){
          this.brands = data.brands.data;
          this.last_page = data.brands.last_page;
          this.page = data.brands.current_page;
          this.loading = false;
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    onFileChange(e) {
      let t = e.target.files[0].type.split('/').pop().toLowerCase();
        if (t != "jpeg" && t != "jpg" && t != "png" && t != "bmp" && t != "gif") {
          this.$refs.file.value = ''
          return this.$toast.error('Загружаемый файл должен быть изображением!')
        }
        if (e.target.files[0].size > 5000000) {
          this.$refs.file.value = ''
          return this.$toast.error('Загружаемый файл должен иметь размер не более 5 мб.!')
        }
        this.file = e.target.files[0];
      },
    fileInput() {
      this.$refs.file.click();
    },
    send() {
      this.$validator.validateAll().then(success => {
        if (success) {
          let formData = new FormData();
          formData.append('file', this.file);
          formData.append('token', localStorage.getItem('token'));
          formData.append('name', this.name ? this.name : '');
          formData.append('status', this.status ? this.status : '');
          this.$http.post( '/create-brand',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then((response) => {
            if (response.data.success) {
              this.getBrands();
              this.file = '';
              this.name = '';
              this.$toast.success('Данные успешно сохранены!');
            }
          }).catch(function(){
            this.$toast.error('Ошибка!');
          })
        }
      })
    }
  },
  watch: {
    page: function (val) {
      if (val >= 1) {
        this.loading = true;
        this.getBrands();
      }
    }
  }
}
</script>

<style>
    .outlined {
        width: 100px !important;
    }
</style>
<style scoped lang="scss">
.brand-img {
    max-width: 40px;
    max-height: 40px;
}
.tc {
    vertical-align: middle;
}
.btn-join {
    padding: 0 16px;
    background: #2CB181;
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    height: 40px;
    border: none;
    outline: none;
    border-radius: 4px;
    width: 160px;
    margin: 10px 0px 5px 8px;
}
.table{
  margin-top: 20px;
  table{
    background: #FFFFFF;
    box-shadow: 0px 0px 3px #E5E5EA;
    border-radius: 4px;
    tr{
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 14px;

      th{
        color: #2D3137;
      }
      td{
        color: #636974;
        &.done{
          color: #2cb181;
        }
      }
    }
  }
}

input {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #7A818F;
    padding: 10px;
    width: 100%;
    height: 40px;
    background: #FFFFFF;
    border: 1px solid #EEF0F3;
    box-sizing: border-box;
    border-radius: 4px;
}


</style>
